export class HashHelper {
  /**
   * Computes the 32-bit FNV-1a hash of the given text and returns it as a hex string.
   */
  static fnv1a32(text: string): string {
    let hash = 0x811c9dc5;

    for (let i = 0; i < text.length; i++) {
      hash ^= text.charCodeAt(i);
      hash = Math.imul(hash, 0x01000193);
    }

    return (hash >>> 0).toString(16);
  }
}
